<template>
  <div class="fg-pcard">
    <div
      :class="!thumbnailUrl ? badge.cls : ''"
      class="fg-pcard-thumb"
    >
      <img
        v-if="thumbnailUrl"
        :src="thumbnailUrl"
        alt="thumbnail"
      >
      <span v-else>{{ badge.label }}</span>
    </div>

    <div class="fg-pcard-badges">
      <span
        :class="ackPill.cls"
        class="fg-pcard-pill"
      >{{ ackPill.label }}</span>
      <faq-guideline-new-badge v-if="item.is_new" />
    </div>

    <h6 class="fg-pcard-title">{{ item.title }}</h6>
    <p
      v-if="publishedOn"
      class="fg-pcard-published"
    >
      <i class="fa fa-calendar" /> Published on {{ publishedOn }}
    </p>
    <p class="fg-pcard-desc">{{ item.description || 'No description' }}</p>

    <button
      type="button"
      class="btn primary btn-sm fg-pcard-btn"
      @click="$emit('detail', item)"
    >
      Details
    </button>
  </div>
</template>

<script>
import FaqGuidelineNewBadge from './faq-guideline-new-badge.vue';

const FILE_BADGES = {
    pdf: { label: 'PDF', cls: 'is-pdf' },
    ppt: { label: 'PPT', cls: 'is-ppt' },
    pptx: { label: 'PPTX', cls: 'is-ppt' },
    txt: { label: 'TXT', cls: 'is-doc' },
    mp4: { label: 'MP4', cls: 'is-video' },
    mov: { label: 'MOV', cls: 'is-video' },
};

export default {
    components: { FaqGuidelineNewBadge },

    props: {
        item: {
            type: Object,
            required: true,
        },
    },

    computed: {
        publishedOn() {
            return this.item.published_at
                ? moment(this.item.published_at).format('DD MMM YYYY')
                : '';
        },

        // Acknowledgement status pill: Unread → Read → Updated (guidelines).
        ackPill() {
            if (this.item.is_acknowledged) {
                return { label: '✓ Read', cls: 'is-read' };
            }
            if (this.item.is_updated_since_ack) {
                return { label: 'Updated', cls: 'is-updated' };
            }
            return { label: 'Unread', cls: 'is-unread' };
        },

        thumbnailUrl() {
            const media = (this.item.media_urls || []).find(
                m => m.collection_name === 'faq_guideline_thumbnail',
            );
            return media ? media.s512 || media.original : null;
        },

        // Colored file-type badge from the first attachment, falling back to a
        // type label when there are no files (mirrors faq-guideline-list.vue).
        badge() {
            const file = (this.item.media_urls || []).find(
                m => m.collection_name === 'faq_guideline_files',
            );

            if (file) {
                const ext = (file.original || '')
                    .split('.')
                    .pop()
                    .toLowerCase();
                if (FILE_BADGES[ext]) {
                    return FILE_BADGES[ext];
                }
            }

            return this.item.type === 'guideline'
                ? { label: 'GUIDE', cls: 'is-doc' }
                : { label: 'FAQ', cls: 'is-faq' };
        },
    },
};
</script>

<style scoped>
.fg-pcard {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
    border: 1px solid #edf0f2;
    border-radius: 10px;
    padding: 20px;
    transition: box-shadow 0.15s ease;
}
.fg-pcard:hover {
    box-shadow: 0 2px 12px rgba(45, 60, 80, 0.08);
}

.fg-pcard-thumb {
    width: 64px;
    height: 64px;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.4px;
    color: #fff;
    background: #adb5bd;
    margin-bottom: 16px;
}
.fg-pcard-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.fg-pcard-thumb.is-pdf {
    background: #e8554e;
}
.fg-pcard-thumb.is-ppt {
    background: #ec894d;
}
.fg-pcard-thumb.is-video {
    background: #4c8bf5;
}
.fg-pcard-thumb.is-doc,
.fg-pcard-thumb.is-faq {
    background: #2a9d8f;
}

.fg-pcard-badges {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
}
.fg-pcard-pill {
    display: inline-flex;
    align-items: center;
    height: 20px;
    padding: 0 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
}
.fg-pcard-pill.is-read {
    background: #e6f6f3;
    color: #2a9d8f;
}
.fg-pcard-pill.is-updated {
    background: #fef3e6;
    color: #c77700;
}
.fg-pcard-pill.is-unread {
    background: #eef1f4;
    color: #6b7785;
}

.fg-pcard-title {
    margin: 0 0 4px;
    font-size: 15px;
    font-weight: 700;
    color: #2b3543;
}
.fg-pcard-published {
    margin: 0 0 8px;
    font-size: 11px;
    color: #a3abb8;
}
.fg-pcard-published .fa {
    margin-right: 4px;
}
.fg-pcard-desc {
    margin: 0 0 18px;
    font-size: 13px;
    line-height: 1.5;
    color: #8a94a6;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.fg-pcard-btn {
    align-self: flex-start;
    margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/faq_guideline/faq-guideline-portal-card.vue